import * as z from "zod";
import {
  BinPrioritySchema,
  PersistentStorageLocationTypeSchema,
  StorageLocationType,
} from "./storage-location";
import {
  CoordinateSchema,
  RackCellSchema,
  WallSchema,
  WarehouseCellSchema,
} from "./warehouse-cell";

const BinCoordinateSchema = z.object({
  isSellable: z.boolean().nullish(),
  x: z.number(),
  y: z.number(),
  type: PersistentStorageLocationTypeSchema.nullish(),
  priority: BinPrioritySchema.nullish(),
});
export type BinCoordinate = z.infer<typeof BinCoordinateSchema>;

/** Returns true if the storage location is pickable.
 * The bin must be mapped (present in binCoordinates). If mapped but has no type, it's pickable.
 * Only BIN type is explicitly pickable; all other types are not. */
export function isPickable(
  binCoordinate: BinCoordinate | null | undefined,
): boolean {
  if (binCoordinate == null) {
    return false;
  }
  return (
    binCoordinate.type == null || binCoordinate.type === StorageLocationType.BIN
  );
}

export const WarehouseGridSchema = z.object({
  width: z.number().int().positive(),
  height: z.number().int().positive(),
  grid: z.array(z.array(WarehouseCellSchema)),
  racks: z.record(z.string(), RackCellSchema),
  walls: z.array(WallSchema),
  binCoordinates: z.record(z.string(), BinCoordinateSchema),
  startVertex: CoordinateSchema.nullish(),
});
export type WarehouseGrid = z.infer<typeof WarehouseGridSchema>;
export interface IWarehouseGridSchema extends z.ZodType<WarehouseGrid> {}
